<purple-api-error-wrapper [enabledErrorPages]="enableErrorPages" [loaderId]="loaderId"></purple-api-error-wrapper>

<purple-loader [speed]="loaderSpeed" [width]="loaderWidth()" loaderPath="/assets/loaders/loader.json" [loaderId]="loaderId"></purple-loader>